export enum Role {
  ROLE_USER = 'ROLE_USER',
  ROLE_SUBSCRIBER = 'ROLE_SUBSCRIBER',
}
